

import * as React from 'react';
import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import Modal from '@mui/material/Modal';
// import { blue } from '@mui/material/colors';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "800px",
  "background-color": "#401404",
  "border-radius": "67px",
  // bgcolor: 'background.paper',
  border: '9px solid red',
  boxShadow: 100,
  p: 10,
};

function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ width: '100%', mr: 1 }}>
          <LinearProgress variant="determinate" {...props} />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" color="white">{`${Math.round(
            props.value,
          )}%`}</Typography>
        </Box>
      </Box>
    );
  }

const TransitionModal=(props) =>{
 let test=props.data;
 let progress=props.progressData

   
  return (
    <div>

      <Modal
        open={test}
        onClose={test}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
        <Box sx={{ width: '100%' }}>
      <LinearProgressWithLabel value={progress} />
    </Box>
    <Typography fontFamily={'Chilanka'} 
    fontStyle={{height:"162px", "padding-top":"73px", "padding-left": "120px",fontSize:'33px', color: "white" , fontWeight: 'bold'}} >Transaction is in process     
</Typography></Box>
      </Modal>
    </div>
  );
}
export default TransitionModal

